<template>
  <div class="pl10 pr10">
    <a-row class="tar mb10" justify="end">
      <a-button type="link" size="small" @click="batchAssign"
        >批量分配</a-button
      >
      <a-button type="primary" size="small" @click="showModal(true)"
        >新增</a-button
      >
    </a-row>
    <a-table
      :row-selection="{
        onChange: setRoleIds,
        selectedRowKeys: assignState.roleIds
      }"
      rowKey="id"
      size="small"
      bordered
      :columns="columns"
      :data-source="roleDatas"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.key === 'action'">
          <a-button type="link" size="small" @click="showAssignModal(record)"
            >关联模块</a-button
          >
          <a-button type="link" size="small" @click="showModal(true, record)"
            >编辑</a-button
          >
          <a-button type="link" size="small" @click="deleteRole(record.id)"
            >删除</a-button
          >
        </template>
      </template>
    </a-table>
    <!-- 新增与编辑角色 -->
    <a-modal
      v-if="formState.visible"
      :open="formState.visible"
      :title="formState.id ? '更新角色' : '新增角色'"
      @ok="submitRole"
      @cancel="showModal(false)"
    >
      <a-form
        ref="formRef"
        :model="formState"
        :labelCol="{ span: 8 }"
        :wrapperCol="{ span: 14 }"
        :rules="rules"
      >
        <a-form-item label="输入角色名称" name="roleName">
          <a-input
            v-model:value="formState.roleName"
            placeholder="请输入"
            autocomplete="off"
          />
        </a-form-item>
      </a-form>
    </a-modal>

    <a-modal
      v-if="isAssignModal"
      v-model:open="isAssignModal"
      title="关联模块"
      @ok="assignSubmit"
      @cancel="isAssignModal = false"
    >
      <a-checkbox-group v-model:value="assignState.moduleIds">
        <a-checkbox
          :value="item.id"
          v-for="item in checkboxDatas"
          :key="item.id"
          >{{ item.moduleName }}</a-checkbox
        >
      </a-checkbox-group>
    </a-modal>
  </div>
</template>
<script setup>
import { reactive, toRefs, ref, inject, onMounted, computed, watch } from 'vue'
import { message } from 'ant-design-vue'
const APIS = inject('APIS')

const { getRoleList, columns, roleDatas } = APIS.v1_portal_role_list_post_()
const {
  formState,
  rules,
  formRef,
  showModal,
  submitRole,
  deleteRole
} = APIS.v1_portal_role_add_post_({
  getRoleList
})

const {
  getModuleListByRoleId,
  moduleList
} = APIS.v1_portal_module_byRoleId_post_()

const { moduleDatas, getModuleList } = APIS.v1_portal_module_list_post_()

const {
  isBatch,
  isAssignModal,
  showAssignModal,
  assignSubmit,
  assignState,
  setRoleIds
} = APIS.assignController(getModuleListByRoleId)

// 批量分配
const batchAssign = () => {
  if (assignState.roleIds.length === 0) {
    message.warning('请优先勾选一条记录')
    return false
  }
  isAssignModal.value = true
  assignState.moduleIds = []
  isBatch.value = true
}
const checkboxDatas = computed(() => {
  return isBatch.value ? moduleDatas.value : moduleList.value
})
watch(
  () => moduleList.value,
  data => {
    assignState.moduleIds = []
    data &&
      data.map(_ => {
        if (_.selected) {
          assignState.moduleIds.push(_.id)
        }
      })
  },
  {
    deep: true
  }
)

onMounted(() => {
  getRoleList()
  getModuleList()
})
</script>
<style lang="scss" scoped></style>
